import { render, staticRenderFns } from "./operateAdd.vue?vue&type=template&id=bef09d5e&scoped=true&"
import script from "./operateAdd.vue?vue&type=script&lang=js&"
export * from "./operateAdd.vue?vue&type=script&lang=js&"
import style0 from "./operateAdd.vue?vue&type=style&index=0&id=bef09d5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef09d5e",
  null
  
)

export default component.exports